window.StorefrontCartAPI = (function () {
  var CONFIG = {
    shopDomain: window.Shopify && window.Shopify.shop ? window.Shopify.shop : 'thn-by-triathlon.myshopify.com',
    storefrontToken: (window.__storefrontConfig && window.__storefrontConfig.token) || 'e2fb2f2225f2b4eabdf5904973f88bdc',
    apiVersion: '2026-04',
  };

  function graphqlQuery(query, variables) {
    console.log('[StorefrontCartAPI] Query:', query.substring(0, 120));
    console.log('[StorefrontCartAPI] Variables:', JSON.stringify(variables).substring(0, 300));

    return fetch('https://' + CONFIG.shopDomain + '/api/' + CONFIG.apiVersion + '/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': CONFIG.storefrontToken,
      },
      body: JSON.stringify({ query: query, variables: variables }),
    }).then(function (res) {
      if (!res.ok) {
        console.error('[StorefrontCartAPI] HTTP error:', res.status, res.statusText);
        throw new Error('Storefront API error: ' + res.status);
      }
      return res.json();
    }).then(function (data) {
      console.log('[StorefrontCartAPI] Response:', JSON.stringify(data).substring(0, 500));
      if (data.errors) {
        console.error('[StorefrontCartAPI] GraphQL errors:', data.errors);
        throw new Error('GraphQL error: ' + data.errors.map(function (e) { return e.message; }).join(', '));
      }
      return data;
    });
  }

  function getCurrentCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (!cart.token || cart.item_count === 0) {
          throw new Error('EMPTY_CART');
        }
        return cart;
      });
  }

  function cartCreate(lines, buyerIdentity, deliveryAddress, discountCodes) {
    var query =
      'mutation CartCreate($input: CartInput!) {' +
      '  cartCreate(input: $input) {' +
      '    userErrors { message field code }' +
      '    cart { id checkoutUrl discountCodes { code } buyerIdentity { email phone countryCode } }' +
      '  }' +
      '}';

    var input = {
      lines: lines,
      buyerIdentity: buyerIdentity,
      discountCodes: discountCodes || [],
      delivery: {
        addresses: [
          {
            address: { deliveryAddress: deliveryAddress },
            selected: true,
            oneTimeUse: true,
            validationStrategy: 'COUNTRY_CODE_ONLY',
          },
        ],
      },
    };

    return graphqlQuery(query, { input: input }).then(function (data) {
      var result = data.data.cartCreate;
      if (result.userErrors && result.userErrors.length > 0) {
        console.error('[StorefrontCartAPI] cartCreate errors:', result.userErrors);
        throw new Error(result.userErrors.map(function (e) { return e.message; }).join(', '));
      }
      return result.cart;
    });
  }

  function cartDeliveryAddressesAdd(cartId, addresses) {
    var query =
      'mutation CartDeliveryAddressesAdd($cartId: ID!, $addresses: [CartSelectableAddressInput!]!) {' +
      '  cartDeliveryAddressesAdd(cartId: $cartId, addresses: $addresses) {' +
      '    userErrors { message field code }' +
      '    cart { id checkoutUrl }' +
      '  }' +
      '}';

    return graphqlQuery(query, { cartId: cartId, addresses: addresses }).then(function (data) {
      var result = data.data.cartDeliveryAddressesAdd;
      if (result.userErrors && result.userErrors.length > 0) {
        console.error('[StorefrontCartAPI] cartDeliveryAddressesAdd errors:', result.userErrors);
        throw new Error(result.userErrors.map(function (e) { return e.message; }).join(', '));
      }
      return result.cart;
    });
  }

  function updateCartAndRedirect(formData) {
    return getCurrentCart().then(function (currentCart) {
      console.log('[StorefrontCartAPI] Current cart:', currentCart.token, 'items:', currentCart.item_count);

      var lines = currentCart.items.map(function (item) {
        return {
          merchandiseId: 'gid://shopify/ProductVariant/' + item.variant_id,
          quantity: item.quantity,
        };
      });

      var discountCodes = (currentCart.discount_codes || [])
        .filter(function (d) { return d.applicable; })
        .map(function (d) { return d.code; });

      var buyerIdentity = {
        email: formData.email,
        phone: formData.phone,
        countryCode: 'PE',
      };

      var address = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        company: formData.company,
        address1: formData.address1,
        address2: formData.address2,
        city: formData.city,
        provinceCode: formData.provinceCode,
        zip: formData.zip,
        countryCode: 'PE',
        phone: formData.phone,
      };

      console.log('[StorefrontCartAPI] Creating new cart with', lines.length, 'items, discountCodes:', discountCodes);

      return cartCreate(lines, buyerIdentity, address, discountCodes).then(function (cart) {
        console.log('[StorefrontCartAPI] Cart created:', cart.id);
        console.log('[StorefrontCartAPI] Checkout URL:', cart.checkoutUrl);

        if (cart.checkoutUrl) {
          window.location.href = cart.checkoutUrl;
        } else {
          window.location.href = '/checkout#shipping_method';
        }
      });
    });
  }

  return {
    updateCartAndRedirect: updateCartAndRedirect,
    getCurrentCart: getCurrentCart,
    cartCreate: cartCreate,
    cartDeliveryAddressesAdd: cartDeliveryAddressesAdd,
  };
})();
